export enum FrequencyEnumMapping {
  Daily = 'Daily',
  Weekly = 'Weekly',
  BiWeekly = 'BiWeekly',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  HalfYearly = 'HalfYearly',
  Annually = 'Annually',
}
